module.exports = __webpack_public_path__ + "static/favicon-984c4cc651a1b83a731d1a83ad96c1d5.ico";